<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<div class="container">
					<div class="form-floating mt-3">
						<select class="form-select" id="status" name="status" [(ngModel)]="filters.status">
							<option value="">Wszystkie</option>
							<option [value]="item.id" *ngFor="let item of paramFilters.yesno">
								{{ item.name }}
							</option>
						</select>
						<label for="status">Archiwum</label>
					</div>

					<div class="mb-5"></div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="container">
					<div class="row">
						<div class="col-sm-7 text-start">
							<button type="button" class="btn btn-danger me-1" (click)="filtersClear()">Wyczyść</button>
							<button type="button" class="btn btn-success" (click)="filtersDefault()">Domyślne</button>
						</div>
						<div class="col-sm-5 text-end">
							<button type="button" class="btn btn-primary me-1" (click)="filtersSave()">Pokaż</button>
							<button
								type="button"
								class="btn btn-secondary"
								(click)="filtersClose()"
								data-bs-dismiss="modal"
							>
								Anuluj
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
